var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insights-page",attrs:{"data-testid":"insights-page"}},[(_vm.hasChartsConfigured)?_c('div',{staticClass:"js-insights-page-container"},[_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.pageConfig.title))]),_vm._v(" "),_c('div',{staticClass:"insights-charts",attrs:{"data-testid":"insights-charts"}},_vm._l((_vm.chartData),function({
            loaded,
            type,
            description,
            data,
            dataSourceType,
            error,
            filterLabels,
            collectionLabels,
            groupBy,
          },key,index){return _c('insights-chart',{key:index,attrs:{"loaded":loaded,"type":type,"title":key,"description":description,"data":data,"data-source-type":dataSourceType,"error":error,"filter-labels":filterLabels,"collection-labels":collectionLabels,"group-by":groupBy},on:{"chart-item-clicked":function($event){return _vm.onChartItemClicked(dataSourceType)}}})}),1)]):_c('gl-empty-state',{attrs:{"title":_vm.emptyState.title,"description":_vm.emptyState.description,"svg-path":"/assets/illustrations/empty-state/empty-dashboard-md.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }